import * as React from "react";

export const ChevronDownIcon: React.FC<{
  className?: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}> = ({ className, size = 20, color = "currentColor", style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    style={style}
    color={color}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.72456 6.64204C3.96864 6.39796 4.36437 6.39796 4.60845 6.64204L9.99984 12.0334L15.3912 6.64204C15.6353 6.39796 16.031 6.39796 16.2751 6.64204C16.5192 6.88612 16.5192 7.28185 16.2751 7.52593L10.4418 13.3593C10.1977 13.6033 9.80197 13.6033 9.5579 13.3593L3.72456 7.52593C3.48048 7.28185 3.48048 6.88612 3.72456 6.64204Z"
      fill={color}
    />
  </svg>
);
